<script setup lang="ts">
import { ActivityDetailsPanelType } from '../models';
import { useActivityDetailsPanelsStore } from '../stores';

import TicketsSelectorPanel from './ticketsSelector/TicketsSelectorPanel.vue';

const activityDetailsPanelsStore = useActivityDetailsPanelsStore();
</script>

<template>
  <TicketsSelectorPanel
    v-if="
      activityDetailsPanelsStore.activityDetailsPanelType ===
      ActivityDetailsPanelType.TicketsSelection
    "
  />
</template>

<style scoped lang="scss"></style>
